import { createFileRoute } from "@tanstack/react-router"
import { EmployerCompanyForm } from "@/features/company"

export const Route = createFileRoute("/recruit/settings/company")({
  component: EmployerCompanySettings,
})

function EmployerCompanySettings() {
  return <EmployerCompanyForm />
}
